export default __webpack_public_path__ + "static/media/Minutes of Annual Stockholders Metting (December 4, 2020).7e5f787c.pdf";